import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getUserTranslations } from "../../api/translation";
import { QueueAI } from "../../types/types";
import styles from "./TranslationQueueCounter.module.css";

interface TranslationQueueCounterProps {
    refreshTrigger?: number;
}

const TranslationQueueCounter: React.FC<TranslationQueueCounterProps> = ({ refreshTrigger = 0 }) => {
    const [queueCounts, setQueueCounts] = useState({ queued: 0, inProgress: 0 });
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    useEffect(() => {
        const fetchQueueCounts = async () => {
            const token = localStorage.getItem("token");
            if (!token) return;

            try {
                const response = await getUserTranslations({ token, page: 1, limit: 50 });
                if (response && response.data) {
                    const activeTranslations = response.data.filter(
                        (translation: QueueAI) =>
                            translation.status === "queued" ||
                            translation.status === "queuedtest" ||
                            translation.status === "in_progress",
                    );

                    const inProgress = activeTranslations.filter(
                        (translation: QueueAI) => translation.status === "in_progress",
                    ).length;

                    const queued = activeTranslations.filter(
                        (translation: QueueAI) =>
                            translation.status === "queued" || translation.status === "queuedtest",
                    ).length;

                    setQueueCounts({ queued, inProgress });
                }
            } catch (err) {
                console.error("Error fetching queue counts:", err);
            }
        };

        fetchQueueCounts();
        const intervalId = setInterval(fetchQueueCounts, 5000);
        return () => clearInterval(intervalId);
    }, [refreshTrigger]);

    return (
        <div className={styles.statusCard}>
            <span className={`${styles.ln}${queueCounts.inProgress > 0 ? ` ${styles.lnActive}` : ""}`}>
                <b>{queueCounts.inProgress}</b> {t("inProgress", { defaultValue: "in progress" })}
            </span>
            <span className={`${styles.ln}${queueCounts.queued > 0 ? ` ${styles.lnQueued}` : ""}`}>
                <b>{queueCounts.queued}</b> {t("queued", { defaultValue: "queued" })}
            </span>
        </div>
    );
};

export default TranslationQueueCounter;
